import {
  Drawer, Toolbar, List, Typography, Divider, ListItem, ListItemIcon, ListItemText, CssBaseline, AppBar
} from '@material-ui/core';
import ViewListIcon from '@material-ui/icons/ViewList';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import React, { PureComponent } from 'react';
import '../../styles/Dashboard.css';
import OrderComponent from './OrderComponent';
import CustomerComponent from './CustomerComponent';
import DriverComponent from './DriverComponent';
import { withRouter } from "react-router-dom";

class DashboardComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'order',
      token: null
    };
  }

  componentDidMount() {
    const { cookies } = this.props;
    const token = cookies.get('token');
    if (!token) {
      this.props.history.replace("/admin/login");
    } else {
      this.setState({
        token
      });
    }
  }

  selectedItem = (val) => {
    this.setState({
      selected: val
    });
  }

  renderInnerContent = () => {
    switch(this.state.selected) {
      case 'order':
        return (<OrderComponent token={this.state.token} logout={this.logout} />);
      case 'customer':
        return (<CustomerComponent token={this.state.token} logout={this.logout} />);
      case 'driver':
        return (<DriverComponent token={this.state.token} logout={this.logout} />);
    }
    return null;
  }

  logout = () => {
    const { cookies } = this.props;
    cookies.remove('token', { path: '/' });
    this.props.history.replace("/admin/login");
  }

  render() {
    return (
      <div className="root">
        <CssBaseline />
        <AppBar position="fixed" className="appBar">
          <Toolbar>
            <Typography variant="h6" noWrap>
              Admin Dashboard
            </Typography>
            <div style={{ marginLeft: 'auto' }}>
              <ExitToAppIcon onClick={this.logout} style={{ cursor: 'pointer' }} />
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          className="drawer"
          variant="permanent"
          anchor="left"
        >
          <Toolbar />
          <div className="drawerContainer">
            <List>
              <ListItem button onClick={() => this.selectedItem('order')} selected={this.state.selected === 'order'}>
                <ListItemIcon><ViewListIcon /></ListItemIcon>
                <ListItemText primary="Orders" />
              </ListItem>
              <ListItem button onClick={() => this.selectedItem('customer')} selected={this.state.selected === 'customer'}>
                <ListItemIcon><PersonIcon /></ListItemIcon>
                <ListItemText primary="Customers" />
              </ListItem>
              <ListItem button onClick={() => this.selectedItem('driver')} selected={this.state.selected === 'driver'}>
                <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
                <ListItemText primary="Drivers" />
              </ListItem>
            </List>
            <Divider />
          </div>
        </Drawer>
        <main className="content">
          <Toolbar />
          {this.state.token && this.renderInnerContent()}
        </main>
      </div>
    )
  }
}

export default withRouter(DashboardComponent);
